import { lazy } from 'solid-js'
import { messages } from '../../pages/native-listings-page/listing-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/native-listings-page/native-listings-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/listing/:property_id',
    showFooter: true,
    showHeaderMenu: false,
    showUserHeader: true,
    titleMessage: messages.titleMessage,
}
